/**
 * gtm.js — Google Tag Manager dataLayer push utility for FinMaple.
 *
 * 4 custom events:
 *   offer_click     — Click on affiliate/product link (revenue signal)
 *   calculator_used — Mortgage calculator interaction (high intent)
 *   comparator_used — Comparator filter/sort/detail interaction (high intent)
 *   quiz_completed  — Financial quiz completed (lead qualification)
 */

function push(event, params) {
  if (typeof window !== 'undefined') {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ event, ...params });
  }
}

/** User clicked an affiliate / product apply link */
export function gtmOfferClick({ product, provider, vertical, url }) {
  push('offer_click', { product, provider, vertical, url });
}

/** User interacted with the mortgage calculator */
export function gtmCalculatorUsed({ calculator, action, value }) {
  push('calculator_used', { calculator, action, value });
}

/** User interacted with a comparator (filter, sort, detail, compare) */
export function gtmComparatorUsed({ vertical, action, detail }) {
  push('comparator_used', { vertical, action, detail });
}

/** User completed a quiz (EmpiezaAqui, AccountPicker, TFSA/RRSP helper) */
export function gtmQuizCompleted({ quiz, segment, locale }) {
  push('quiz_completed', { quiz, segment, locale });
}

/** User submitted a newsletter subscription */
export function gtmNewsletterSubmit({ source }) {
  push('newsletter_submit', { source });
}
